import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from './views/Dashboard.vue'
import ConfirmOrders from './views/ConfirmOrders.vue'
import DispatchOrders from './views/DispatchOrders.vue'
import SearchOrders from './views/SearchOrders.vue'
import Messages from './views/Messages.vue'
import EbayOrder from './views/EbayOrder.vue'
import CartEditor from './views/CartEditor.vue'
import ItemEditor from './views/ItemEditor.vue'
import EbayItemEditor from './views/EbayItemEditor.vue'
import PostalrateEditor from './views/PostalrateEditor'
import PaymentsOverview from './views/PaymentsOverview'

Vue.use(Router)

export default new Router({
  mode: 'history',
//  base: '/admin/',
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: Dashboard
    },
    {
      path: '/order-confirm',
      name: 'order-confirm',
      component: ConfirmOrders
    },
    {
      path: '/order-dispatch',
      name: 'order-dispatch',
      component: DispatchOrders
    },
    {
      path: '/order-search',
      name: 'search',
      component: SearchOrders
    },
    {
      path: '/messages',
      name: 'messages',
      component: Messages
    },
    {
      path: '/order-ebay',
      name: 'ebay-order',
      component: EbayOrder
    },
    {
      path: '/cart-edit',
      name: 'cart-editor',
      component: CartEditor
    },
    {
      path: '/item-edit',
      name: 'item-editor',
      component: ItemEditor
    },
    {
      path: '/ebay-edit',
      name: 'ebay-item-editor',
      component: EbayItemEditor
    },
    {
      path: '/postal-rate-edit',
      name: 'postal-rate-editor',
      component: PostalrateEditor
    },
    {
      path: '/payments-overview',
      name: 'payments-overview',
      component: PaymentsOverview
    },
    {
      path: '*',
      redirect: 'dashboard',
    },
  ]
})
